import { useMemo } from 'react'
import { useT } from '../../../../../../_metronic/i18n/Metronici18n'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { NotaVersaoList } from '../../core/_models'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useListFilters } from '../../core/ListFiltersProvider'
import { notasVersaoColumns } from './columns/_columns'

export const NotasVersaoTable = () => {
  const { t } = useT()
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { hasFilters, clearFilters } = useListFilters()
  const columns = useMemo(() => notasVersaoColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title={t('notas_versao.vazio_filtro.titulo')}
      description={t('notas_versao.vazio_filtro.descricao')}
      action={{ label: t('notas_versao.filtro.limpar'), onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title={t('notas_versao.vazio.titulo')}
      description={t('notas_versao.vazio.descricao')}
    />
  )

  return (
    <CustomTable<NotaVersaoList>
      id='kt_table_notas_versao'
      ariaLabel={t('menu.nav.notas_versao')}
      itemLabel={{
        singular: t('notas_versao.item.singular'),
        plural: t('notas_versao.item.plural'),
      }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
